
import { Shield, MapPin, CreditCard, Clock } from "lucide-react";
import { useEffect, useState } from "react";

const features = [
  {
    icon: MapPin,
    title: "Easy Location Search",
    description: "Find parking spots near you or search any location manually",
    gradient: "from-blue-500 to-blue-600",
    delay: 100
  },
  {
    icon: Shield,
    title: "Secure Spaces",
    description: "All parking spots are verified and monitored for your safety",
    gradient: "from-green-500 to-green-600",
    delay: 300
  },
  {
    icon: CreditCard,
    title: "Simple Payments",
    description: "Pay securely online with multiple payment options",
    gradient: "from-purple-500 to-purple-600",
    delay: 500
  },
  {
    icon: Clock,
    title: "24/7 Availability",
    description: "Book parking spots anytime, anywhere with instant confirmation",
    gradient: "from-orange-500 to-orange-600",
    delay: 700
  },
];

const Features = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="py-24 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="container mx-auto px-4">
        <h2 className={`text-4xl font-bold text-center mb-4 ${isVisible ? 'animate-slide-in-bottom' : 'opacity-0'}`}>
          Why Choose Easy Parking?
        </h2>
        <p className={`text-lg text-gray-600 text-center mb-16 max-w-2xl mx-auto ${isVisible ? 'animate-slide-in-bottom' : 'opacity-0'}`} style={{ animationDelay: "200ms" }}>
          Experience hassle-free parking with our innovative solutions
        </p>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className={`group relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 overflow-hidden transform hover:-translate-y-2 ${isVisible ? 'animate-slide-in-bottom' : 'opacity-0'}`}
              style={{ animationDelay: `${feature.delay}ms` }}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${feature.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`} />
              <div className="relative z-10">
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center mb-6 transform group-hover:scale-110 transition-transform duration-300 animate-pulse-glow`}>
                  <feature.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-semibold mb-3 group-hover:text-primary-800 transition-colors">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
                <div className="h-1 w-0 bg-gradient-to-r from-blue-500 to-blue-300 mt-4 group-hover:w-full transition-all duration-300 rounded-full"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
